let url = window.location.host;//域名
let DOMAIN_URL="guoan";
if(eval('/^guoan.*/gi').test(url)){
    DOMAIN_URL="guoan";
}else if (eval('/^demo.*/gi').test(url)) {
    DOMAIN_URL="demo";
}
// 请求目标服务器域名配置
const DOMAIN_NAME = {
    AI_URL: 'wss://api.acme-ai.com/asr',          // tts调用域名
    AI_URL_TTS: 'https://api.acme-ai.com/asr',    // rtc正式环境
    URL_CNODEJS: 'https://api.acme-ai.com/gafc/webapi/soccer',    // 正式环境
    TEST_URL_CNODEJS: 'https://api.test.acme-ai.com/gafc/webapi/soccer',    // 测试环境
    // TEST_URL_CNODEJS: 'http://10.0.0.95:99/webapi/basketball',    // 测试环境
};
export default {
    DOMAIN_NAME,
    DOMAIN_URL
};
